import { useIntercom } from "react-use-intercom";

import Banner from "common/components/subscriptions/Banner";
import { Button } from "common/components/ui/Button";
import type { Pricing } from "common/types";

export default function Alerts({
  currentStep,
  pricing,
  isUnchangedSubscription,
  isDowngrade,
}: {
  currentStep: "manage" | "summary";
  pricing: { addon: Pricing; plan: Pricing };
  isUnchangedSubscription: boolean;
  isDowngrade: boolean;
}) {
  const { showNewMessage } = useIntercom();

  if (currentStep === "manage") {
    if (isDowngrade) {
      return (
        <Banner
          textNode="Outreach Avatars cannot be cancelled through the dashboard, please contact our team to downgrade your subscription"
          variant="warning"
          ctaComponent={
            <Button
              variant="secondary-black"
              size="sm"
              className="ml-auto"
              onClick={() => {
                showNewMessage(
                  "Hello, i would like to cancel my outreach avatar seats",
                );
              }}
            >
              Contact support
            </Button>
          }
        />
      );
    } else if (
      pricing.plan.period_unit === "month" &&
      pricing.plan.period === 6 &&
      !isUnchangedSubscription
    ) {
      return (
        <Banner
          key={4}
          variant="gradient"
          textNode="You’re signing up for a 6-month plan. Future purchases and plan updates will follow this same 6-month billing cycle"
        />
      );
    }
  } else if (currentStep === "summary") {
    return (
      <Banner
        textNode="Outreach Avatars need some time to be prepared by our team and assigned to your account. They will show up in your dashboard within 2 business days"
        variant="warning"
      />
    );
  }
}
